import { render, staticRenderFns } from "./TemplatesProject.vue?vue&type=template&id=4bcc9e3e&scoped=true&"
import script from "./TemplatesProject.vue?vue&type=script&lang=js&"
export * from "./TemplatesProject.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesProject.vue?vue&type=style&index=0&id=4bcc9e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc9e3e",
  null
  
)

export default component.exports